import ApiServices, { InstanceKeys } from "@/api/apexchat.api.services";
import { LeadAPI } from "@/api/endpoints";
import { createSlice } from "@reduxjs/toolkit";

export const listSlice = createSlice({
  name: "list",
  initialState: {
    list: null,
    dropdownOptions: {},
    listGridSettings: {
      columns: null,
      columnFilters: null,
      sortingInfo: null,
    },
  },

  reducers: {
    setListToState: (state, action) => {
      state.list = action.payload;
    },
    setListGridSettingsToState: (state, action) => {
      state.listGridSettings = action.payload;
    },
  },
});

export const {
  setListToState,
  setListGridSettingsToState,
} = listSlice.actions;

export const selectList = (state) => {
  return state.list;
};

export const getListInfo = (state) => {
  return state.list.list;
};

export const getLeadGridSettings = (state) => {
  return state.crmLeads.leadGridSettings;
};


export default listSlice.reducer;
